import gql from 'graphql-tag'

export const INDEX = gql`
  query people_index($page: Int!, $perPage: Int!) {
    people(page: $page, perPage: $perPage) {
      nodes {
        id
        name
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
